/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EnrollmentScheduleDto } from '../models/enrollment-schedule-dto';
import { enrollmentScheduleGroupControllerCancel } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-cancel';
import { EnrollmentScheduleGroupControllerCancel$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-cancel';
import { enrollmentScheduleGroupControllerCopy } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-copy';
import { EnrollmentScheduleGroupControllerCopy$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-copy';
import { enrollmentScheduleGroupControllerCreate } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-create';
import { EnrollmentScheduleGroupControllerCreate$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-create';
import { enrollmentScheduleGroupControllerCreateSupplement } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-create-supplement';
import { EnrollmentScheduleGroupControllerCreateSupplement$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-create-supplement';
import { enrollmentScheduleGroupControllerDelete } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-delete';
import { EnrollmentScheduleGroupControllerDelete$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-delete';
import { enrollmentScheduleGroupControllerDeleteRepeat } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-delete-repeat';
import { EnrollmentScheduleGroupControllerDeleteRepeat$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-delete-repeat';
import { enrollmentScheduleGroupControllerFindSchedulesByGroupId } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-find-schedules-by-group-id';
import { EnrollmentScheduleGroupControllerFindSchedulesByGroupId$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-find-schedules-by-group-id';
import { enrollmentScheduleGroupControllerFindServiceByCenterChildIds } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-find-service-by-center-child-ids';
import { EnrollmentScheduleGroupControllerFindServiceByCenterChildIds$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-find-service-by-center-child-ids';
import { enrollmentScheduleGroupControllerUpdateDate } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-update-date';
import { EnrollmentScheduleGroupControllerUpdateDate$Params } from '../fn/enrollment-schedule-group/enrollment-schedule-group-controller-update-date';
import { FindServiceResponseDto } from '../models/find-service-response-dto';

@Injectable({ providedIn: 'root' })
export class EnrollmentScheduleGroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `enrollmentScheduleGroupControllerFindSchedulesByGroupId()` */
  static readonly EnrollmentScheduleGroupControllerFindSchedulesByGroupIdPath = '/api/enrollment-schedule-group';

  /**
   * 그룹 ID로 일정 그룹 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerFindSchedulesByGroupId()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerFindSchedulesByGroupId$Response(params: EnrollmentScheduleGroupControllerFindSchedulesByGroupId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentScheduleDto>>> {
    return enrollmentScheduleGroupControllerFindSchedulesByGroupId(this.http, this.rootUrl, params, context);
  }

  /**
   * 그룹 ID로 일정 그룹 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerFindSchedulesByGroupId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerFindSchedulesByGroupId(params: EnrollmentScheduleGroupControllerFindSchedulesByGroupId$Params, context?: HttpContext): Observable<Array<EnrollmentScheduleDto>> {
    return this.enrollmentScheduleGroupControllerFindSchedulesByGroupId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EnrollmentScheduleDto>>): Array<EnrollmentScheduleDto> => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleGroupControllerCreate()` */
  static readonly EnrollmentScheduleGroupControllerCreatePath = '/api/enrollment-schedule-group';

  /**
   * 서비스 일정 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleGroupControllerCreate$Response(params: EnrollmentScheduleGroupControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleGroupControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleGroupControllerCreate(params: EnrollmentScheduleGroupControllerCreate$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleGroupControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleGroupControllerDelete()` */
  static readonly EnrollmentScheduleGroupControllerDeletePath = '/api/enrollment-schedule-group';

  /**
   * 그룹 일정 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerDelete$Response(params: EnrollmentScheduleGroupControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleGroupControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 그룹 일정 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerDelete(params: EnrollmentScheduleGroupControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleGroupControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleGroupControllerFindServiceByCenterChildIds()` */
  static readonly EnrollmentScheduleGroupControllerFindServiceByCenterChildIdsPath = '/api/enrollment-schedule-group/service';

  /**
   * 아동 ID로 서비스 찾기.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerFindServiceByCenterChildIds()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerFindServiceByCenterChildIds$Response(params: EnrollmentScheduleGroupControllerFindServiceByCenterChildIds$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FindServiceResponseDto>>> {
    return enrollmentScheduleGroupControllerFindServiceByCenterChildIds(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동 ID로 서비스 찾기.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerFindServiceByCenterChildIds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerFindServiceByCenterChildIds(params: EnrollmentScheduleGroupControllerFindServiceByCenterChildIds$Params, context?: HttpContext): Observable<Array<FindServiceResponseDto>> {
    return this.enrollmentScheduleGroupControllerFindServiceByCenterChildIds$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FindServiceResponseDto>>): Array<FindServiceResponseDto> => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleGroupControllerCreateSupplement()` */
  static readonly EnrollmentScheduleGroupControllerCreateSupplementPath = '/api/enrollment-schedule-group/supplement';

  /**
   * 전체 보강 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerCreateSupplement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleGroupControllerCreateSupplement$Response(params: EnrollmentScheduleGroupControllerCreateSupplement$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleGroupControllerCreateSupplement(this.http, this.rootUrl, params, context);
  }

  /**
   * 전체 보강 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerCreateSupplement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleGroupControllerCreateSupplement(params: EnrollmentScheduleGroupControllerCreateSupplement$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleGroupControllerCreateSupplement$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleGroupControllerUpdateDate()` */
  static readonly EnrollmentScheduleGroupControllerUpdateDatePath = '/api/enrollment-schedule-group/date';

  /**
   * 전체 일정 날짜 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerUpdateDate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleGroupControllerUpdateDate$Response(params: EnrollmentScheduleGroupControllerUpdateDate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleGroupControllerUpdateDate(this.http, this.rootUrl, params, context);
  }

  /**
   * 전체 일정 날짜 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerUpdateDate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleGroupControllerUpdateDate(params: EnrollmentScheduleGroupControllerUpdateDate$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleGroupControllerUpdateDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleGroupControllerCopy()` */
  static readonly EnrollmentScheduleGroupControllerCopyPath = '/api/enrollment-schedule-group/copy';

  /**
   * 전체 복사.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerCopy()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerCopy$Response(params: EnrollmentScheduleGroupControllerCopy$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleGroupControllerCopy(this.http, this.rootUrl, params, context);
  }

  /**
   * 전체 복사.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerCopy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerCopy(params: EnrollmentScheduleGroupControllerCopy$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleGroupControllerCopy$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleGroupControllerCancel()` */
  static readonly EnrollmentScheduleGroupControllerCancelPath = '/api/enrollment-schedule-group/cancel';

  /**
   * 전체 취소.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerCancel()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerCancel$Response(params: EnrollmentScheduleGroupControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleGroupControllerCancel(this.http, this.rootUrl, params, context);
  }

  /**
   * 전체 취소.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerCancel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerCancel(params: EnrollmentScheduleGroupControllerCancel$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleGroupControllerCancel$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleGroupControllerDeleteRepeat()` */
  static readonly EnrollmentScheduleGroupControllerDeleteRepeatPath = '/api/enrollment-schedule-group/repeat';

  /**
   * 서비스 반복 일정 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleGroupControllerDeleteRepeat()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerDeleteRepeat$Response(params: EnrollmentScheduleGroupControllerDeleteRepeat$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleGroupControllerDeleteRepeat(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 반복 일정 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleGroupControllerDeleteRepeat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleGroupControllerDeleteRepeat(params: EnrollmentScheduleGroupControllerDeleteRepeat$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleGroupControllerDeleteRepeat$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
